import { apiClient } from './client';
import type { Gruppe } from '../types/gruppe';
import type { Listing, VerfahrenListItem, Anfrage } from '../types';
import type { PaginatedResponse } from '../types/api';

export type GruppeListResponse = PaginatedResponse<Gruppe>;

export interface GruppeCreateData {
  name: string;
  beschreibung?: string;
  listing_ids?: number[];
}

export interface AssignmentChangeBody {
  new_user_id: number | null;
  context: string | null;
}

export const gruppeApi = {
  getGruppen: async (
    params: {
      page?: number;
      per_page?: number;
      search_text?: string;
      sort_by?: string;
      sort_dir?: 'asc' | 'desc';
      include_hidden?: boolean;
    } = {},
  ): Promise<GruppeListResponse> => {
    const { data } = await apiClient.get('/gruppen/', { params });
    return data;
  },

  getGruppe: async (id: number): Promise<Gruppe> => {
    const { data } = await apiClient.get(`/gruppen/${id}`);
    return data;
  },

  createGruppe: async (body: GruppeCreateData): Promise<Gruppe> => {
    const { data } = await apiClient.post('/gruppen/', body);
    return data;
  },

  updateGruppe: async (id: number, updates: Partial<GruppeCreateData>): Promise<Gruppe> => {
    const { data } = await apiClient.patch(`/gruppen/${id}`, updates);
    return data;
  },

  deleteGruppe: async (id: number): Promise<void> => {
    await apiClient.delete(`/gruppen/${id}`);
  },

  restoreGruppe: async (id: number): Promise<void> => {
    await apiClient.post(`/gruppen/${id}/restore`);
  },

  changeAssignment: async (id: number, body: AssignmentChangeBody): Promise<Gruppe> => {
    const { data } = await apiClient.patch(`/gruppen/${id}/zustaendig`, body);
    return data;
  },

  getInserate: async (id: number): Promise<Listing[]> => {
    const { data } = await apiClient.get(`/gruppen/${id}/inserate`);
    return data;
  },

  getVerfahren: async (id: number): Promise<VerfahrenListItem[]> => {
    const { data } = await apiClient.get(`/gruppen/${id}/verfahren`);
    return data;
  },

  getAnfragen: async (id: number): Promise<Anfrage[]> => {
    const { data } = await apiClient.get(`/gruppen/${id}/anfragen`);
    return data;
  },

  addListings: async (id: number, listing_ids: number[]): Promise<Gruppe> => {
    const { data } = await apiClient.post(`/gruppen/${id}/listings`, { listing_ids });
    return data;
  },

  removeListing: async (id: number, listingId: number): Promise<Gruppe> => {
    const { data } = await apiClient.delete(`/gruppen/${id}/listings/${listingId}`);
    return data;
  },
};
